export const AUTH_TOKEN = '@intermediador-auth-token'
export const LOGIN_WITH_TOKEN = '@one-id-auth-token'
export const ACCOUNT_TOKEN = '@account-token'
